import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'
import type { TutorSlotLog } from '@ts-tutor-slot-log/interfaces'
import type { TutorSlotLogStore } from './interfaces'

import { isFullArray } from '@helpers/array'

const getLogsPaginatedData = (state: TutorSlotLogStore): TutorSlotLogStore['logsPaginatedData'] => state.logsPaginatedData || null
const getMeta = (state: TutorSlotLogStore): Meta | null => getLogsPaginatedData(state)?.meta || null
const getLogs = (state: TutorSlotLogStore): TutorSlotLog[] => state.logsPaginatedData?.logs || []

const getSlotStart = (state: TutorSlotLogStore): string | null => {
  if (!state.filterDate || !state.filterSlotTime) return null
  return `${state.filterDate} ${state.filterSlotTime}:00`
}

export const getters = {
  isLoading: (state: TutorSlotLogStore): TutorSlotLogStore['loading'] => state.loading,
  getFilterTutorId: (state: TutorSlotLogStore): TutorSlotLogStore['filterTutorId'] => state.filterTutorId,
  getFilterDate: (state: TutorSlotLogStore): TutorSlotLogStore['filterDate'] => state.filterDate,
  getFilterSlotTime: (state: TutorSlotLogStore): TutorSlotLogStore['filterSlotTime'] => state.filterSlotTime,
  getSelectedTutorOption: (state: TutorSlotLogStore): AppSelectOption<number> | null => state.selectedTutorOption,
  getLogsPaginatedData: (state: TutorSlotLogStore): TutorSlotLogStore['logsPaginatedData'] => getLogsPaginatedData(state),
  getLogs: (state: TutorSlotLogStore): TutorSlotLog[] => getLogs(state),
  hasLogs: (state: TutorSlotLogStore): boolean => isFullArray(getLogs(state)),
  getMeta: (state: TutorSlotLogStore): Meta | null => getMeta(state),
  getCurrentPage: (state: TutorSlotLogStore): number => getMeta(state)?.current_page || 1,
  getLastPage: (state: TutorSlotLogStore): number => getMeta(state)?.last_page || 1,
  getPerPage: (state: TutorSlotLogStore): number => getMeta(state)?.per_page || 25,
  getSlotStart: (state: TutorSlotLogStore): string | null => getSlotStart(state),
  isSearchable: (state: TutorSlotLogStore): boolean =>
    state.filterTutorId !== null && state.filterDate !== null && state.filterSlotTime !== null,
}
